import { render, staticRenderFns } from "./SnackBarsList.vue?vue&type=template&id=2190f61a&scoped=true&"
import script from "./SnackBarsList.vue?vue&type=script&lang=js&"
export * from "./SnackBarsList.vue?vue&type=script&lang=js&"
import style0 from "./SnackBarsList.vue?vue&type=style&index=0&id=2190f61a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2190f61a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem})
